// extracted by mini-css-extract-plugin
export default {"link":"MainPage_link__BBcXy"};